import { urls } from './urls';

export interface Descriptor {
    url: string;
    jwt: string;
}

export const createDescriptorIfPrivate = (url: string, jwt: string | null) => {
    return url.startsWith(urls.privateAssetsBaseUrl) || url.startsWith(urls.oldPrivateAssetsBaseUrl)
        ? JSON.stringify({ url, jwt })
        : url;
};

export const isDescriptor = (descriptor: string) => {
    return descriptor.startsWith('{');
};

export const parseDescriptor = (descriptor: string) => {
    return JSON.parse(descriptor) as Descriptor;
};

export const createAuthorizationHeader = (jwt: string) => ({
    'Authorization': `Bearer ${jwt}`
});